<template>
  <div class="bg" style="background: url(static/img/background.jpg)">
    <v-container grid-list-lg class="mb-5 responsive-container">
      <v-layout row justify-center wrap>
        <BackSimulator></BackSimulator>
        <v-flex xs12 md6 lg4>
          <img src="static/logo/logo.svg" width="60%" class="mx-auto mt-2" />
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">Dados Pessoais</h1>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Nome *</p>
                    <v-text-field
                      ref="nome"
                      solo
                      hide-details
                      v-model="form.nome"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.telefone.focus()"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Telefone *</p>
                    <v-text-field
                      ref="telefone"
                      type="tel"
                      inputmode="tel"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      v-model="form.telefone"
                      placeholder="(00) 00000-0000"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.email.focus()"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">E-mail *</p>
                    <v-text-field
                      ref="email"
                      type="email"
                      solo
                      hide-details
                      v-model="form.email"
                      :error="emailError"
                      :error-messages="emailError ? ['E-mail inválido'] : []"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.empresa.focus()"
                      @blur="validateEmail"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Empresa (Razão Social) *</p>
                    <v-text-field
                      ref="empresa"
                      solo
                      hide-details
                      v-model="form.empresa"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.cargo.focus()"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Cargo *</p>
                    <v-text-field
                      ref="cargo"
                      solo
                      hide-details
                      v-model="form.cargo"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.custo.focus()"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">
            Formulário de Chiller
          </h1>
        </v-flex>
        <v-flex xs12>
          <v-card class="card-custom mb-2">
            <v-card-text class="card-custom-text">
              <v-container fluid>
                <v-layout row wrap align-end>
                  <v-flex xs12 sm12 md6 lg4 class="text-xs-left">
                    <p class="caption mb-2">Custo da Energia (R$/MWh) *</p>
                    <v-text-field
                      ref="custo"
                      v-model="form.custo"
                      v-money="money"
                      solo
                      hide-details
                      inputmode="decimal"
                      placeholder="Ex.: 450,00"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.nome_equipamento[0].focus()"
                    />
                    <p class="mb-0">(Energia + Encargos + Impostos)</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          v-for="(item, index) in equipamentos"
          :key="index"
          class="mb-4"
        >
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 class="pt-2">
                    <div class="simulator-card-title">
                      <p
                        class="primary--text text-uppercase font-weight-bold mb-0"
                      >
                        Chiller {{ index + 1 }}
                      </p>
                      <v-tooltip top v-if="index !== 0">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="ml-auto mr-0"
                            v-on="on"
                            @click="removeCard(index)"
                          >
                            <v-icon>mdi mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md6 lg4 class="text-xs-left">
                    <p class="caption mb-2">Dias Operação/Mês *</p>
                    <!-- <v-text-field
                      ref="dias_operacao_mes"
                      v-model="item.dias_operacao_mes"
                      v-mask="'##'"
                      solo
                      hide-details
                      placeholder="Ex.: 30"
                      append-icon="mdi mdi-calendar-range"
                      @blur="validateRange(item, 'dias_operacao_mes', 1, 31)"
                    /> -->

                    <v-select
                      ref="dias_operacao_mes"
                      v-model="item.dias_operacao_mes"
                      solo
                      hide-details
                      :items="dias_mes"
                      @change="validateRange(item, 'dias_operacao_mes', 1, 31)"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg4 class="text-xs-left">
                    <p class="caption mb-2">Horas de Operação/Dia *</p>
                    <v-select
                      v-model="item.horas_operacao_dia"
                      solo
                      hide-details
                      :items="horas_dias"
                      @change="validateRange(item, 'horas_operacao_dia', 1, 24)"
                    ></v-select>
                    <!-- <v-text-field
                      v-model="item.horas_operacao_dia"
                      v-mask="'##'"
                      solo
                      hide-details
                      placeholder="Ex.: 18"
                      append-icon="mdi mdi-timer"
                      @blur="validateRange(item, 'horas_operacao_dia', 1, 24)"
                    /> -->
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg4 class="text-xs-left">
                    <p class="caption mb-2">Quantidade *</p>
                    <v-text-field
                      v-model="item.quantidade"
                      solo
                      hide-details
                      v-money="money0"
                      placeholder="Ex.: 2"
                    />
                  </v-flex>

                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Modelo do Chillhers *</p>
                    <v-select
                      ref="nome_equipamento"
                      v-model="item.modelo_chillers"
                      :items="modelosChillers"
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Ano Fabricação *</p>
                    <v-text-field
                      v-model="item.ano_fabricacao"
                      v-mask="'####'"
                      solo
                      hide-details
                      placeholder="Ex.: 2018"
                      append-icon="mdi mdi-calendar"
                      @blur="validateYear(item, 'ano_fabricacao')"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Capacidade Nominal (TR) *</p>
                    <v-text-field
                      v-model="item.capacidade_tr"
                      solo
                      v-money="money0"
                      hide-details
                      inputmode="decimal"
                      placeholder="Ex.: 250"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Potência Nominal (kW) *</p>
                    <v-text-field
                      v-model="item.potencia_nominal_kw"
                      solo
                      hide-details
                      inputmode="decimal"
                      v-money="money0"
                      placeholder="Ex.: 180"
                      append-icon="mdi mdi-flash"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Fator de Carga (%) *</p>
                    <v-text-field
                      v-model="item.fator_carga"
                      solo
                      hide-details
                      v-money="money0"
                      placeholder="Ex.: 80"
                      append-icon="mdi mdi-percent"
                      @blur="validateRange(item, 'fator_carga', 1, 100)"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Regime de Operação *</p>
                    <v-select
                      v-model="item.regime_operacao"
                      :items="regimeOperacao"
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Comparar *</p>
                    <v-select
                      v-model="item.comparar"
                      :items="modelosChillers"
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>

                  <v-flex
                    xs12
                    sm12
                    md4
                    lg3
                    class="text-xs-right aling-self-end"
                  >
                    <div class="hidden-sm-and-down" style="height: 32px"></div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          color="primary"
                          class="ml-auto mr-1"
                          v-on="on"
                          @click="addCard"
                        >
                          <v-icon>mdi mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 class="text-xs-right pb-5">
          <v-btn color="primary" @click="sendForm()">
            Enviar dados
            <v-icon right>mdi mdi-send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
try {
  var _base = require("@/page/_base.vue").default;
} catch (err) {
  var _base = require("@/framework/page/_base.vue").default;
}

import { VMoney } from "v-money";
import Swal from "sweetalert2";
import { mask } from "vue-the-mask";
import BackSimulator from "@/page/widget/backSimulator.vue";

const createEquipamento = () => ({
  dias_operacao_mes: "",
  horas_operacao_dia: "",
  quantidade: 0,
  modelo_chillers: "",
  ano_fabricacao: "",
  capacidade_tr: 0,
  potencia_nominal_kw: 0,
  fator_carga: 0,
  regime_operacao: "",
  comparar: "",
});

export default {
  extends: _base,
  directives: {
    money: VMoney,
    mask,
  },
  components: {
    BackSimulator,
  },
  data() {
    return {
      dias_mes: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      horas_dias: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24,
      ],
      endpoint: global.config.endpoint,
      form: {
        nome: "",
        telefone: "",
        email: "",
        empresa: "",
        cargo: "",
        custo: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: false,
      },
      money0: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 0,
        masked: false,
      },
      emailError: false,
      modelosChillers: [
        "Scroll a Ar",
        "Scroll a Água",
        "Parafuso a Ar",
        "Parafuso a Água",
        "Centrífugo a Água",
      ],
      regimeOperacao: ["Principal", "Backup"],
      equipamentos: [createEquipamento()],
      payloadPreview: null,
    };
  },
  methods: {
    retorna() {
      this.$router.back();
    },
    async sendForm() {
      let error = "";

      if (this.emailError) {
        error = "Por favor, informe um e-mail válido";
      }

      if (this.form.cargo == "") {
        error = "Informe o cargo";
      }

      if (this.form.empresa == "") {
        error = "Informe a razão social";
      }

      if (this.form.email == "") {
        error = "Inserir o e-mail";
      }

      if (this.form.telefone == "") {
        error = "Informe o telefone";
      }
      if (this.form.nome == "") {
        error = "Informa o nome";
      }

      let valor = parseFloat(
        this.form.custo.toString().replace(/\./g, "").replace(",", ".")
      );
      if (valor == "" || valor <= 0) {
        error = "Informe o custo da energia";
      }

      if (error != "") {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                       ${error}
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      const camposObrigatorios = [
        "dias_operacao_mes",
        "horas_operacao_dia",
        "quantidade",
        "modelo_chillers",
        "ano_fabricacao",
        "capacidade_tr",
        "potencia_nominal_kw",
        "fator_carga",
        "regime_operacao",
        "comparar",
      ];

      let possuiCamposInvalidos = this.equipamentos.some((subestacao) => {
        return camposObrigatorios.some((campo) => {
          const valor = subestacao[campo];

          return (
            valor === null || valor === undefined || String(valor).trim() === ""
          );
        });
      });

      if (possuiCamposInvalidos) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Preencha todos os campos do formulário
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      this.salvaPlanilha();
    },
    async salvaPlanilha() {
      const formData = {
        form: this.form,
        equipamentos: this.equipamentos,
      };

      Swal.showLoading();
      let valores = JSON.stringify(formData);

      let res = await this.callLocalAction("save_estudo", {
        dados: valores,
      });

      if (res && res.ok && res.ok.ok) {
        Swal.fire({
          icon: "success",
          title:
            "<strong style='font-size: 20px !important;'>Resultado enviado</strong>",
          html: `
              <div style="padding: 10px;">
                  <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                    O resultado da simulação foi enviado para o e-mail informado: <b>${this.form.email}</b>
                  </p>
                </div>
            `,
          confirmButtonText: "Ok",
          confirmButtonColor: "#68b842",
        }).then(async () => {
          this.retorna();
        });
      } else {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Erro ao salvar</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Não foi possível realizar o estudo
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }
    },
    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !regex.test(this.form.email);
    },
    validateYear(item, field) {
      const year = Number(item[field]);
      const currentYear = new Date().getFullYear();

      if (!year || year < 1821 || year > currentYear) {
        item[field] = "";
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Ano de Fabricação</strong>",
          html:
            "<div style='padding: 10px;'><p style='font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;'>Informe um ano entre <b>" +
            1821 +
            "</b> e <b>" +
            currentYear +
            "</b>.</p></div>",
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      }
    },
    validateRange(item, field, min, max) {
      const value = Number(item[field]);

      if (!value || value < min || value > max) {
        item[field] = "";
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Valor inválido</strong>",
          html:
            "<div style='padding: 10px;'><p style='font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;'>Informe um valor entre <b>" +
            min +
            "</b> e <b>" +
            max +
            "</b>.</p></div>",
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      }
    },
    validateRequired() {
      if (this.emailError) return "Por favor, informe um e-mail válido";
      if (!this.form.custo) return "Informe o custo da energia";
      if (!this.form.cargo) return "Informe o cargo";
      if (!this.form.empresa) return "Informe a razão social";
      if (!this.form.email) return "Informe o e-mail";
      if (!this.form.telefone) return "Informe o telefone";
      if (!this.form.nome) return "Informe o nome";

      const requiredFields = [
        "dias_operacao_mes",
        "horas_operacao_dia",
        "quantidade",
        "modelo_chillers",
        "ano_fabricacao",
        "capacidade_tr",
        "potencia_nominal_kw",
        "fator_carga",
        "regime_operacao",
        "comparar",
      ];

      const hasInvalidEquipamento = this.equipamentos.some((equipamento) =>
        requiredFields.some((field) => !equipamento[field])
      );

      if (hasInvalidEquipamento) {
        return "Preencha todos os campos obrigatórios dos chillers";
      }

      return "";
    },
    prepareForm() {
      const error = this.validateRequired();

      if (error) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html:
            "<div style='padding: 10px;'><p style='font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;'>" +
            error +
            "</p></div>",
          confirmButtonText: "Ok",
        });
        return;
      }

      this.payloadPreview = {
        tipo_simulador: "chiller",
        form: { ...this.form },
        equipamentos: this.equipamentos.map((equipamento) => ({
          ...equipamento,
        })),
      };

      Swal.fire({
        icon: "success",
        title:
          "<strong style='font-size: 20px !important;'>Estrutura pronta</strong>",
        html: "<div style='padding: 10px;'><p style='font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;'>Os dados foram validados e o payload foi preparado localmente. Nenhuma informação foi salva no banco.</p></div>",
        confirmButtonText: "Ok",
        confirmButtonColor: "#68b842",
      });
    },
    addCard() {
      this.equipamentos.push(createEquipamento());
    },
    removeCard(index) {
      if (this.equipamentos.length === 1) return;
      this.equipamentos.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.card-custom {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: tint($body-color, 70%);
  border: 1px solid tint($brand-primary, 90%) !important;
  border-radius: 2.4rem !important;
  margin-bottom: -16px;

  .card-custom-text {
    padding: 16px !important;
  }
}

.simulator-card-title {
  display: flex;
  align-items: center;
}

.v-select__selection.v-select__selection--comma,
.v-input {
  font-size: 14px !important;
}

.v-text-field__details {
  display: none !important;
}

.primary {
  background-color: $brand-default !important;
  border-color: $brand-default !important;
}

.responsive-container {
  max-width: 1264px;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 960px) {
    max-width: 100%;
  }
}
</style>
